import { CloseIcon, Modal, ArrowBackIcon, Typography, useClickOutside } from '@hermes/web-components'
import React, { useRef } from 'react'
import {
  ModalCloseButton,
  ModalBackButton,
  ModalTitleContainer,
  ModalContainer,
  ModalContent
} from './BaseModal.styles'

interface BaseModalProps {
  isOpen: boolean
  title?: string
  onClose: () => void
  children: React.ReactNode
  width?: number
  button?: []
  backButton?: boolean
  backAction?: () => void
}

const BaseModal = ({ isOpen, title, backButton, backAction, onClose, children, width = 666 }: BaseModalProps) => {
  const baseModalRef = useRef(null)
  useClickOutside(baseModalRef, () => onClose())
  return (
    <Modal open={isOpen} onClose={onClose}>
      <ModalContainer>
        <ModalContent
          ref={baseModalRef}
          sx={{
            width: `${width}px`
          }}
        >
          {title && (
            <ModalTitleContainer>
              {backButton && (
                <ModalBackButton onClick={backAction} variant="ghost">
                  <ArrowBackIcon width="20px" />
                </ModalBackButton>
              )}
              <Typography>{String(title)}</Typography>
              <ModalCloseButton onClick={onClose} variant="ghost">
                <CloseIcon width="20px" />
              </ModalCloseButton>
            </ModalTitleContainer>
          )}
          {children}
        </ModalContent>
      </ModalContainer>
    </Modal>
  )
}
export default BaseModal
